import React from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import {
  ArrowBack as BackIcon,
  MoneyOff as WriteoffIcon
} from '@mui/icons-material';

import { useAppSelector } from '../../../../app/store';
import { SaveChangesButton, SubmitForApprovalButton, ResubmitButton, PostButton, CancelButton } from '../commands';

interface WriteoffEditHeaderProps {
  onBack: () => void;
  onError: (message: string | null) => void;
}

const WriteoffEditHeader: React.FC<WriteoffEditHeaderProps> = ({
  onBack,
  onError,
}) => {
  const { currentWriteoff, isEdited } = useAppSelector(state => state.writeoff);
  const id = currentWriteoff?.identifiers?.id || '';
  const status = currentWriteoff?.status || 'Draft';

  return (
    <Box sx={{
      backgroundColor: '#ffffff',
      borderBottom: '2px solid #3b82f6',
      p: 1.5
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={4}>
          <WriteoffIcon sx={{ color: '#3b82f6', fontSize: 28 }} />
          <Box>
            <Typography variant="h4" component="h1" fontWeight={600} color="#1e293b">
              Writeoff Request
            </Typography>
            <Typography variant="body1" color="#64748b">
              Managing writeoff request #{id} • Status: <strong>{status}</strong>
            </Typography>
          </Box>
        </Box>
        <Stack direction="row" spacing={1} sx={{ ml: 4 }}>
          <Button 
            variant="outlined" 
            startIcon={<BackIcon />}
            onClick={onBack}
            sx={{ 
              minWidth: 120, 
              height: 40, 
              textTransform: 'none',
              fontWeight: 500 
            }}
          >
            Go Back
          </Button>
          <Stack direction="row" spacing={1}>
            <SaveChangesButton 
              onError={onError}
              onSuccess={() => onError(null)}
            />
            <SubmitForApprovalButton onError={onError} />
            <ResubmitButton onError={onError} />
            <PostButton onError={onError} />
            <CancelButton onClick={onBack} />
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default WriteoffEditHeader;
